import { Button } from "@/components/ui/button";
import { Phone, Mail, MessageCircle } from "lucide-react";
import heroImage from "@/assets/hero-industrial.jpg";
import { useLanguage } from "@/contexts/LanguageContext";
import { PHONE_DISPLAY, TEL_HREF, buildWhatsAppUrl } from "@/lib/phone";

const WHATSAPP_URL_EN = buildWhatsAppUrl("Hello Arabian Al Waha, I need manpower / equipment.");
const WHATSAPP_URL_AR = buildWhatsAppUrl("مرحباً العربية الواحة، أحتاج عمالة / معدات.");

const CtaContact = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const t = {
    h1: isAr ? "تحتاج عمالة" : "Need Manpower",
    h2: isAr ? "أو معدات؟" : "or Equipment?",
    p: isAr ? "تواصل معنا اليوم للحصول على دعم سريع وموثوق." : "Contact us today for fast and reliable support.",
    whatsapp: isAr ? "واتساب الآن" : "WhatsApp Now",
    call: isAr ? "اتصل الآن" : "Call Now",
  };
  return (
    <section id="contact-cta" data-on-dark className="py-24 bg-primary-darker text-primary-foreground relative overflow-hidden">
      <img
        src={heroImage}
        alt=""
        aria-hidden="true"
        loading="lazy"
        width={1920}
        height={1080}
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-darker via-primary-darker/85 to-primary-darker/60" />

      <div className="container mx-auto px-6 lg:px-8 relative text-center max-w-3xl">
        <h2 className="heading-brand-on-dark text-4xl sm:text-5xl lg:text-6xl uppercase mb-4 leading-tight">
          {t.h1} <span className="brand-accent">{t.h2}</span>
        </h2>
        <p className="text-xl text-primary-foreground/80 mb-10">
          {t.p}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <Button asChild size="lg" className="bg-accent hover:bg-accent/90 text-primary-darker font-bold px-8 py-6 text-base uppercase tracking-wide shadow-elegant">
            <a href={isAr ? WHATSAPP_URL_AR : WHATSAPP_URL_EN} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="w-5 h-5 mr-2" /> {t.whatsapp}
            </a>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-2 border-accent/70 text-accent hover:bg-accent hover:text-primary-darker bg-transparent font-bold px-8 py-6 text-base uppercase tracking-wide">
            <a href={TEL_HREF}>
              <Phone className="w-5 h-5 mr-2" /> {t.call}
            </a>
          </Button>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-primary-foreground/90">
          <a href={TEL_HREF} className="flex items-center gap-2 hover:text-accent transition-colors">
            <Phone className="w-5 h-5 text-accent" />
            <bdi dir="ltr" className="font-semibold font-mono">{PHONE_DISPLAY}</bdi>
          </a>
          <a href="mailto:sales@arabianalwaha.com" className="flex items-center gap-2 hover:text-accent transition-colors">
            <Mail className="w-5 h-5 text-accent" />
            <span className="font-semibold">sales@arabianalwaha.com</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaContact;